import { keysOf } from '@betterplace/utils'
import { useMemo } from 'react'
import { useNativePaymentMethodsContext } from '../NativePaymentMethodsContext'

function useNativePaymentMethodsAreAvailable() {
  const { loading, available } = useNativePaymentMethodsContext()
  const anyAvailable = useMemo(() => !!keysOf(available).find((key) => available[key]), [available])
  return !loading && anyAvailable
}

export default useNativePaymentMethodsAreAvailable
